"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newDeferedQueue = exports.newDefered = exports.newPromiseChain = exports.waitFor = exports.deferCall = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var deferCall = function deferCall(f, timeout) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      try {
        resolve(f());
      } catch (error) {
        reject(error);
      }
    }, timeout);
  });
};

exports.deferCall = deferCall;

var waitFor = function waitFor(predicate, timeout) {
  return predicate() ? Promise.resolve() : deferCall(function () {
    return waitFor(predicate, timeout);
  }, timeout);
};

exports.waitFor = waitFor;

var newPromiseChain = function newPromiseChain() {
  var head = Promise.resolve();
  return {
    append: function append(thunk) {
      var promise = head.then(function () {
        return thunk();
      });
      head = promise["catch"](function () {// Ignore errors to not break the chain. Let the consumer of
        // `promise` handle it.
      });
      return promise;
    }
  };
};

exports.newPromiseChain = newPromiseChain;

var newDefered = function newDefered() {
  var resolve;
  var reject;
  var promise = new Promise(function (resolvePromise, rejectPromise) {
    resolve = resolvePromise;
    reject = rejectPromise;
  });
  return {
    promise: promise,
    resolve: resolve,
    reject: reject
  };
};

exports.newDefered = newDefered;

var newDeferedQueue = function newDeferedQueue() {
  var queue = [];
  return {
    enqueue: function enqueue(item) {
      var _newDefered = newDefered(),
          promise = _newDefered.promise,
          resolve = _newDefered.resolve,
          reject = _newDefered.reject;

      queue.push({
        item: item,
        resolve: resolve,
        reject: reject
      });
      return promise;
    },
    process: function process(handler) {
      var clone = queue.slice();
      queue.length = 0;
      clone.forEach( /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
          var item, resolve, reject;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  item = _ref.item, resolve = _ref.resolve, reject = _ref.reject;
                  _context.prev = 1;
                  _context.t0 = resolve;
                  _context.next = 5;
                  return handler(item);

                case 5:
                  _context.t1 = _context.sent;
                  (0, _context.t0)(_context.t1);
                  _context.next = 12;
                  break;

                case 9:
                  _context.prev = 9;
                  _context.t2 = _context["catch"](1);
                  reject(_context.t2);

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 9]]);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  };
};

exports.newDeferedQueue = newDeferedQueue;